module.exports = __webpack_public_path__ + "c4a504bed241e3d6dc69a972ffd3a00d.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/logos/mercedes.svg
// module id = DT8R
// module chunks = 0